import {
  FETCH_BRAND_DETAILS_BEGIN,
  FETCH_BRAND_DETAILS_SUCCESS,
  FETCH_BRAND_DETAILS_FAILURE
} from '../constants/brandActionTypes';

const initialState = {
  brands: [],
  isLoading: true,
  contentLoaded: false,
  error: {}
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    state = initialState;
  }
  switch (action.type) {
    case FETCH_BRAND_DETAILS_BEGIN:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_BRAND_DETAILS_SUCCESS:
      return {
        ...state,
        brands: action.payload,
        isLoading: false,
        contentLoaded: true
      };
    case FETCH_BRAND_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        contentLoaded: true
      };
    default:
      return state;
  }
}
